import { memo } from "react";

import OwnerAnimalSelect from "../../components/multiforms/OwnerAnimalSelect";

const CreateLambing = () => {
    return (
        <OwnerAnimalSelect type={"CreateLambing"} />
    )
};

export default memo(CreateLambing)